/**
 * Typed API client for the Time Clock (timeman) — Epic 220.
 *
 * Per-user work clock-in/out with pause/resume and a history of workdays.
 * Mirrors internal/timeman.
 */

import { apiClient } from '@/lib/apiClient';

export type WorkdayStatus = 'open' | 'paused' | 'closed' | 'anonymous';

export interface TimeStatus {
  status: WorkdayStatus;
  workdayId?: string;
  openedAt?: string;
  totalPauseMinutes?: number;
}

export interface Workday {
  id: string;
  openedAt: string;
  closedAt: string | null;
  totalPauseMinutes: number;
  location: string | null;
}

export async function getStatus(): Promise<TimeStatus> {
  const { data } = await apiClient.get<TimeStatus>('/timeman/status');
  return data;
}

export async function openWorkday(location?: string): Promise<{ workdayId: string }> {
  const { data } = await apiClient.post<{ workdayId: string }>('/timeman/open', { location });
  return data;
}

export async function closeWorkday(notes?: string): Promise<{ ok: boolean }> {
  const { data } = await apiClient.post<{ ok: boolean }>('/timeman/close', { notes });
  return data;
}

export async function pauseWorkday(): Promise<{ ok: boolean }> {
  const { data } = await apiClient.post<{ ok: boolean }>('/timeman/pause', {});
  return data;
}

export async function resumeWorkday(): Promise<{ ok: boolean }> {
  const { data } = await apiClient.post<{ ok: boolean }>('/timeman/resume', {});
  return data;
}

export async function listHistory(): Promise<Workday[]> {
  const { data } = await apiClient.get<Workday[]>('/timeman/history');
  return data;
}
